import { alpha, styled, Typography } from '@mui/material';
import { common } from '@mui/material/colors';

import { COLOR_GREY_1 } from '@/dmdrive/ui-kit/colors';

export const UserMenuRoot = styled('div')(({ isOpened }: { isOpened: boolean }) => ({
  display: 'flex',
  alignItems: 'center',
  borderRadius: '1.4rem',
  cursor: 'pointer',
  padding: '0.2rem',
  backgroundColor: isOpened ? COLOR_GREY_1 : 'transparent',
  transition: 'background-color 300ms ease-in-out',
}));

export const UserName = styled('div')({
  padding: '0 0.5rem',
});

export const UserMenuIcon = styled('div')(({ isOpened }: { isOpened: boolean }) => ({
  color: alpha(common.black, 0.5),
  transform: `rotate(${isOpened ? 180 : 0}deg)`,
  transition: 'transform 300ms ease-in-out',
  '& svg': {
    display: 'block',
  },
}));

export const UserAccountInfo = styled('div')({
  padding: '0.75rem 1rem',
});

export const UserEmail = styled(Typography)({
  color: alpha(common.black, 0.6),
});
